import { useQuery } from "@tanstack/react-query";
import { getDeliveryCoupons, getPodCoupons } from "src/api/coupon";
export const usePodCouponQuery = (param)=>{
    let { enabled  } = param;
    return useQuery({
        queryKey: [
            "getPodCoupons"
        ],
        queryFn: ()=>getPodCoupons(),
        enabled
    });
};
export const useDeliveryCouponQuery = (param)=>{
    let { enabled , type  } = param;
    return useQuery({
        queryKey: [
            "getDeliveryCoupons"
        ],
        queryFn: ()=>getDeliveryCoupons(type),
        enabled
    });
};
